import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { Container } from 'components/basics';
import { breakpoint } from 'utils/mediaQueries';
import AddressBlock from 'components/pages/Qemotion/ContactBlock/AddressBlock';
import ContactUsBlock from 'components/pages/Qemotion/ContactBlock/ContactUs/ContactUsBlock';
import { FormattedMessage } from 'react-intl';
import { colors } from 'styles';

const ContentBlock = styled(Grid)`
  max-width: 1200px;
  width: 100%;
  ${breakpoint.down('md')`
  padding-top: 4rem;
  flex-direction: column-reverse`}
`;

const AddressTitle = styled(Typography)`
  padding: 0 1rem;
  margin-bottom: -1rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  color: ${colors.orange};
  line-height: 2rem;
  font-family: ${props => `${props.theme.typography.fontFamily}`};
  ${breakpoint.down('md')`
  font-size: ${props => `${props.theme.typography.body1.fontSize}px`};
    justify-content: center;`}
`;
const StyledGrid = styled(Grid)`
  flex: 0 0 auto;
`;
const ContactBlocks = ({ data, lang }) => {
  return (
    <Container>
      <ContentBlock container spacing={40} justify="center">
        <StyledGrid
          container
          direction={'column'}
          item
          xs={'auto'}
          sm={12}
          md={5}
          lg={5}
        >
          <AddressTitle variant={'h6'}>
            <FormattedMessage id="qemotionPage.addresses" />
          </AddressTitle>
          {data.markdownContent.map((block, index) => (
            <AddressBlock data={block} key={`AddressBlock${index}`} />
          ))}
        </StyledGrid>
        <StyledGrid
          container
          direction={'column'}
          item
          xs={'auto'}
          sm={12}
          md={6}
          lg={5}
        >
          <ContactUsBlock data={data.contactUs} lang={lang} />
        </StyledGrid>
      </ContentBlock>
    </Container>
  );
};

export default ContactBlocks;
